import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Soir / coucher de soleil — demi-soleil + horizon duotone */
export const EveningIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Demi-soleil menthe */}
      <path
        d="M6 17a6 6 0 0 1 12 0"
        fill="var(--equiply-icon-bg)"
      />
      <path
        d="M6 17a6 6 0 0 1 12 0"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Ligne d'horizon */}
      <path
        d="M2 17h20"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Rayons */}
      <path
        d="M12 4v3M4.5 9l1.5 1.5M19.5 9L18 10.5M2 13h2.5M19.5 13H22"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      {/* Flèche descendante (coucher) */}
      <path
        d="M14 21l-2 1.5L10 21"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  ),
);
EveningIcon.displayName = "EveningIcon";
